// SWAN Design System Colors

export const colors = {
  // PRIMARY COLORS
  sapphire: '#1C50C4',
  frenchBlue: '#143C82',

  // SECONDARY COLORS
  drySage: '#D6CA98',
  goldenBronze: '#C89D46',

  // NEUTRAL COLORS
  porcelain: '#F0F4EF',
  deepCharcoal: '#000500',
};

export default colors;
